import React from "react";

type InputProps = {
    input: any;
}

export const TextInputField = (props: InputProps) => {
    const { input } = props;
    return (
        <input
            id={input.id}
            type="text"
            defaultValue={input.initialValue}
            placeholder={input.placeholder}
            onChange={input.valueChangeHandler}
            onBlur={input.inputBlurHandler}
        />)
}

export const FormField = (props: InputProps) => {
    const { input } = props;

    return (
        <div className="col">
            <TextInputField input={input} />
            <label htmlFor={input.id}>{input.placeholder}</label>
            <ValidationMessage input={input} />
        </div>
    );
}

export const ValidationMessage = (props: InputProps) => {
    const { input } = props;
    if (!input.isTouched || !input.hasError) {
        return null;
    }

    return (
        <div className="card-text sub-text err-msg">{input.validationMessage}</div>
    );
}

export default { TextInputField, FormField, ValidationMessage };
